document.addEventListener('DOMContentLoaded', () => {
  // Skip if metafields dropdown already exists (prevents duplicate)
  if (document.querySelector('#new-selector-metafields')) {
    return;
  }

  let variantWrapper = document.querySelector('.variant-wrapper.js');
  if (!variantWrapper) {
    return;
  }

  let dropdownContent = document.querySelector('.dropdown-content');

function updateRadioButtonSelection(value) {

  document.querySelector('.value-selected-size').textContent = value;
  
  // Identify if the value is a size or bundle
  if (value === "Standard" || value === "Thick") {
    // Select the corresponding size radio button
    const sizeRadioButton = document.querySelector(`input[name="Height"][value="${value}"]`);
    if (sizeRadioButton) {
      sizeRadioButton.checked = true;
      const changeEvent = new Event('change', { bubbles: true });
      sizeRadioButton.dispatchEvent(changeEvent);
    }
  } else {
    // Select the corresponding bundle radio button
    const bundleRadioButton = document.querySelector(`input[name="Bundle"][value="${value}"]`);
    if (bundleRadioButton) {
      bundleRadioButton.checked = true;
      const changeEvent = new Event('change', { bubbles: true });
      bundleRadioButton.dispatchEvent(changeEvent);
    }
  }
}

if (dropdownContent) {
  dropdownContent.addEventListener('click', (event) => {
    const selectedDiv = event.target.closest('.variant-option');
    if (selectedDiv) {
      // Remove "active" class from any previously selected variant-option
      const activeVariantOption = dropdownContent.querySelector('.variant-option.active');
      if (activeVariantOption) {
        activeVariantOption.classList.remove('active');
      }

      const selectedValue = selectedDiv.querySelector('input[type="radio"]').value;
      updateRadioButtonSelection(selectedValue);

      // Add "active" class to the newly selected variant-option
      selectedDiv.classList.add('active');

      dropdownContent.style.display = 'none';
    }
  });
}
})
